import { render, staticRenderFns } from "./user-alerts.vue?vue&type=template&id=d5b4c986"
import script from "./user-alerts.vue?vue&type=script&lang=js"
export * from "./user-alerts.vue?vue&type=script&lang=js"
import style0 from "./user-alerts.vue?vue&type=style&index=0&id=d5b4c986&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports